/* eslint-disable no-undef */
import React from 'react'
import { addFieldMap } from './IntegrationHelpers/IntegrationHelpers'
import { refreshFields, refreshOrganizations } from './ZohoInventoryCommonFunc'
import ZohoInventoryFieldMap from './ZohoInventoryFieldMap'
import ZohoInventorySalesActions from './ZohoInventorySalesActions'
const isPro = typeof bc_inventory_connector !== 'undefined' && bc_inventory_connector.isPro

export default function ZohoInventoryIntegLayout({ handleInput, wcInventoryConf, setWcInventoryConf, isLoading, setisLoading, setSnackbar }) {
  const wcCheckoutFieldOptions = () => wcInventoryConf?.default?.allFields && Object.keys(wcInventoryConf.default.allFields.wcCheckoutFields).map((checkoutKey, indx) => {
    const groupObj = {
      title: checkoutKey, type: 'group', emptyDataLabel: 'No Group Option Found'
    }

    const childs = wcInventoryConf.default.allFields.wcCheckoutFields[checkoutKey]

    if (Array.isArray(childs)) {
      groupObj.childs = childs.map(childKey => ({ label: `${checkoutKey} - ${childs[childKey].label}`, value: childKey }))
    } else if (typeof childs === 'object') {
      groupObj.childs = Object.keys(childs).map(childKey => ({ label: `${checkoutKey} - ${childs[childKey].label}`, value: childKey }))
    } else {
      groupObj.childs = []
    }
    if (indx === Object.keys(wcInventoryConf.default.allFields.wcCheckoutFields).length - 1) {
      groupObj.childs.push({ label: 'Custom Value', value: 'custom' })
    }
    return groupObj
  })

  return (
    <>
      <br />
      <b className="wdt-100 d-in-b">Organization:</b>
      <select onChange={handleInput} name="orgId" value={wcInventoryConf.orgId} className="btcd-paper-inp w-7">
        <option value="">Select Portal</option>
        {
          wcInventoryConf?.default?.organizations && Object.values(wcInventoryConf.default.organizations).map(organization => (
            <option key={organization.orgId} value={organization.orgId}>
              {organization.orgName}
            </option>
          ))
        }
      </select>
      <button onClick={() => refreshOrganizations(wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)} className="icn-btn sh-sm ml-2 mr-2 tooltip" style={{ '--tooltip-txt': '"Refresh Organization"' }} type="button" disabled={isLoading}>&#x21BB;</button>
      <br />
      <br />
      {wcInventoryConf?.orgId &&
        ['inventoryCustomerFields', 'inventorySalesFields'].map(fldType =>
          <div key={fldType} className="pos-rel">
            {!isPro && fldType === 'inventorySalesFields' && (
              <div className="pro-blur flx" style={{ top: -25, width: '110%' }}>
                <div className="pro">
                  Available On
            <a href="https://boostedcrm.com/" target="_blank" rel="noreferrer"><span className="txt-pro"> Premium</span></a>
                </div>
              </div>
            )}
            <div className="mt-4">
              <b className="wdt-100">Map Fields (Zoho Inventory {fldType === 'inventoryCustomerFields' ? 'Customer' : 'Sales Order'})</b>
              <button onClick={() => refreshFields(wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)} className="icn-btn sh-sm ml-2 mr-2 tooltip" style={{ '--tooltip-txt': '"Refresh Fields"' }} type="button" disabled={isLoading}>&#x21BB;</button>
            </div>
            <div className="btcd-hr mt-1" />
            <div className="flx flx-around mt-2 mb-1">
              <div className="txt-dp"><b>WooCommerce Checkout Fields</b></div>
              <div className="txt-dp"><b>Zoho Inventory Fields</b></div>
            </div>

            {wcInventoryConf.field_map?.[fldType]?.map((itm, i) => (
              <ZohoInventoryFieldMap
                key={`desk-m-${i + 9}`}
                i={i}
                type={fldType}
                field={itm}
                wcInventoryConf={wcInventoryConf}
                setWcInventoryConf={setWcInventoryConf}
                wcCheckoutFieldOptions={wcCheckoutFieldOptions}
              />
            ))}
            <div className="txt-center  mt-2" style={{ marginRight: 85 }}><button onClick={() => addFieldMap(wcInventoryConf.field_map[fldType].length, fldType, wcInventoryConf, setWcInventoryConf)} className="icn-btn sh-sm" type="button">+</button></div>
            <br />
            <br />
            <div className="btcd-hr mt-1" />
            {fldType === 'inventorySalesFields' && (
            <div className='flx'>
              <ZohoInventorySalesActions
                  wcInventoryConf={wcInventoryConf}
                  setWcInventoryConf={setWcInventoryConf}
                  isLoading={isLoading}
                  setisLoading={setisLoading} 
                  setSnackbar = {setSnackbar} 
                />

            </div>

            
            )}
             
          </div>
        )}
      <br />
    </>
  )
}
